module.exports = __webpack_public_path__ + "img/pota-content-clip.a608c9c5.jpg";